import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@Component({
  selector: 'app-financial-year-onboarding-wizard',
  templateUrl: './financial-year-onboarding-wizard.component.html',
  styleUrls: ['./financial-year-onboarding-wizard.component.scss'],
})
export class FinancialYearOnboardingWizardComponent {
  dontShowAgain = false;
  isClosing = false;
  private readonly STORAGE_KEY = 'financial_year_onboarding_dismissed';
  private readonly CLOSE_ANIMATION_MS = 700;

  constructor(
    public activeModal: NgbActiveModal,
    private router: Router,
    private localizationService: LocalizationService
  ) {}

  get isRtl(): boolean {
    return (this.localizationService.getCachedLanguage() ?? 'en') === 'ar';
  }

  onStartSetup(): void {
    if (this.isClosing) return;
    this.isClosing = true;
    if (this.dontShowAgain) {
      this.setDismissedPreference();
    }
    setTimeout(() => {
      this.activeModal.close();
      this.router.navigate(['/fiscal-years/financial-year/create/new']);
    }, this.CLOSE_ANIMATION_MS);
  }

  onRemindLater(): void {
    if (this.dontShowAgain) {
      this.setDismissedPreference();
    }
    this.activeModal.dismiss();
  }

  onDontShowAgainChange(checked: boolean): void {
    this.dontShowAgain = checked;
  }

  private setDismissedPreference(): void {
    try {
      localStorage.setItem(this.STORAGE_KEY, 'true');
    } catch {
      // ignore
    }
  }

  static isDismissed(): boolean {
    try {
      return localStorage.getItem('financial_year_onboarding_dismissed') === 'true';
    } catch {
      return false;
    }
  }
}
